module.exports = __webpack_public_path__ + "img/add.48961de4.png";